<div *ngIf="!isSnow" class="amadeus-direct-style">
  <div class="row">
    <img
      class="img-fluid col-lg-12 mx-0 px-0 g-0"
      alt="Responsive banner"
      src="/assets/images/banner/plusme-banner.png"
    />
  </div>
</div>
<div class="bg-gray px-lg-10 px-md-10" *ngIf="(loyaltyConfig$ | async)?.customerConfig as loyaltyConfig">
  <div class="container loyalty-participation__top px-lg-10 px-md-10">
    <div class="row px-lg-8 px-md-8">
      <div class="col-lg-8">
        <div class="loyalty-participation__top-box" id="agents-participation">
          <h2>{{ loyaltyAgentsParticipationBoxTitleString }} : {{ loyaltyAmadeusPlusMeString }}</h2>
          <ul class="loyalty-participation__top-benefits list-unstyled">
            <li>
              <span class="benefit-icon"><span class="fa-check"></span></span
              ><span class="benefit-desc">{{ loyaltyAgentsParticipationBenefitsMotivateString }}</span>
            </li>
            <li>
              <span class="benefit-icon"><span class="fa-check"></span></span
              ><span class="benefit-desc">{{ loyaltyAgentsParticipationBenefitsRewardString }}</span>
            </li>
            <li>
              <span class="benefit-icon"><span class="fa-check"></span></span
              ><span class="benefit-desc">{{ loyaltyAgentsParticipationBenefitsSaleString }}</span>
            </li>
          </ul>
          <form [formGroup]="participationForm" (ngSubmit)="approveParticipation()">
            <div class="form-check form-check-hebrew">
              <input
                id="participationAllow"
                class="form-check-input form-checkbox-hebrew"
                type="checkbox"
                [attr.disabled]="loyaltyConfig.loyalty_enabled_for_account || null"
                [checked]="loyaltyConfig.loyalty_enabled_for_account"
                formControlName="participationAllowControl"
                #checkbox
              />
              <label for="participationAllow" class="form-check-label">
                {{ loyaltyAgentsParticipationCheckboxLabelString }}
                <a href="{{ termsLink }}">
                  <span i18n="@@loyalty-agents-participation.loyaltyAgentsTermsAndConditions"
                    >terms and conditions</span
                  >
                </a>
              </label>
            </div>
            <button
              *ngIf="!loyaltyConfig.loyalty_enabled_for_account"
              type="submit"
              id="agentsParticipateAgree"
              class="btn btn-primary mt-2"
              [disabled]="!checkbox.checked"
              i18n="@@loyalty-agents-participation.loyaltyAgentsParticipationAllowanceButton"
            >
              Approve access
            </button>
          </form>
          <p
            *ngIf="loyaltyConfig.loyalty_enabled_for_account"
            class="participation-notes mb-0"
            innerHTML="{{ loyaltyAgentsParticipationChangeParticipationNotesString }}  {{
              getContactUsLink(loyaltyAgentsParticipationChangeParticipationNotesLinkString)
            }}"
          ></p>
        </div>
      </div>
    </div>
  </div>
</div>
<spinner *ngIf="isLoading" [fixed]="true"></spinner>
